import React, { useEffect, useState, useContext } from "react";
import {
  MdElectricCar,
  MdSpeed,
  MdTerrain,
  MdAutoAwesome,
  MdWorkspacePremium,
} from "react-icons/md";
import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";
import "./VoyahTaishanExtras.css";

const CARD_ICONS = [MdTerrain, MdSpeed, MdElectricCar, MdAutoAwesome];

const VoyahTaishanExtras = () => {
  const { currentLang } = useContext(LanguageContext);

  const [extras, setExtras] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadExtras = async () => {
      try {
        setLoading(true);
        const response = await getPageContent("voyahtaishan", currentLang);
        setExtras(response.sections?.extras || null);
      } catch (err) {
        console.error("Failed to load Voyah Taishan extras", err);
      } finally {
        setLoading(false);
      }
    };

    loadExtras();
  }, [currentLang]);

  if (loading || !extras) return null;

  const cards = [1, 2, 3, 4]
    .map((n) => ({
      title: extras[`feature_${n}_title`],
      description: extras[`feature_${n}_description`],
    }))
    .filter((card) => card.title || card.description);

  return (
    <section className="vt-extras">
      <div className="vt-extras-container">
        <div className="vt-extras-header">
          {extras.title ? (
            <h2 className="vt-extras-title">{extras.title}</h2>
          ) : null}
          {extras.subtitle ? (
            <p className="vt-extras-subtitle">{extras.subtitle}</p>
          ) : null}
        </div>

        <div className="vt-extras-grid">
          {cards.map((card, index) => {
            const Icon = CARD_ICONS[index];

            return (
              <div key={index} className="vt-extras-card">
                <Icon className="vt-extras-icon" />
                {card.title ? <h3>{card.title}</h3> : null}
                {card.description ? (
                  <p className="vt-extras-description">{card.description}</p>
                ) : null}
              </div>
            );
          })}
        </div>

        {extras.positioning_line ? (
          <div className="vt-extras-positioning">
            <MdWorkspacePremium className="vt-extras-position-icon" />
            <span>{extras.positioning_line}</span>
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default VoyahTaishanExtras;
